import React from 'react';
import { Button } from './Button';
export function PurchaseSection() {
  return <section id="compra" className="py-8 md:py-14 px-3 bg-brand-card border-y-2 border-brand-accent scroll-mt-10 relative overflow-hidden" data-id="element-157">
      {/* Soft background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-brand-accent/10 blur-[100px] rounded-full pointer-events-none" data-id="element-158"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-159">
        <div className="text-center mb-7" data-id="element-160">
          <h2 className="text-2xl md:text-5xl font-black text-white uppercase tracking-tight mb-2" data-id="element-161">
            🎉 OFERTA ESPECIAL
          </h2>
          <p className="text-xs md:text-base text-gray-400 font-bold uppercase tracking-widest" data-id="element-162">
            Elegí tu pack y empezá hoy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-163">
          {/* Offer 1 - With animated gradient border */}
          <div className="relative rounded-xl p-[2px] bg-gradient-to-br from-brand-accent via-brand-neon to-brand-accentDark shadow-[0_0_25px_rgba(212,161,75,0.3)]" data-id="element-164">
            <div className="bg-brand-dark rounded-xl p-4 md:p-6 flex flex-col h-full" data-id="element-165">
              <div className="text-center mb-4 border-b border-white/10 pb-4" data-id="element-166">
                <h3 className="text-sm md:text-lg font-black text-brand-neon mb-1 uppercase tracking-widest" data-id="element-167">
                  ⚡ OFERTA #1
                </h3>
                <h4 className="text-lg md:text-2xl font-black text-white uppercase leading-tight" data-id="element-168">
                  MEGA PACK HERRERÍA MODERNA
                </h4>
              </div>

              <p className="text-gray-300 font-medium mb-3 text-center text-xs md:text-base" data-id="element-169">
                Incluye todo el sistema completo con:
              </p>

              <ul className="space-y-1.5 mb-5 flex-grow text-xs md:text-base font-bold text-white" data-id="element-170">
                <li data-id="element-171">👉 escaleras,</li>
                <li data-id="element-172">👉 pérgolas,</li>
                <li data-id="element-173">👉 puertas modernas,</li>
                <li data-id="element-174">👉 portones,</li>
                <li data-id="element-175">👉 y diseños premium extra.</li>
              </ul>

              <div className="bg-brand-card p-3 rounded-lg mb-5 border border-white/5 space-y-1 text-[11px] md:text-sm font-bold text-brand-accent" data-id="element-176">
                <p data-id="element-177">🎁 Acceso inmediato</p>
                <p data-id="element-178">🎁 Archivos PDF</p>
                <p data-id="element-179">🎁 Acceso de por vida</p>
              </div>

              <div className="text-center mb-5" data-id="element-180">
                <p className="text-sm md:text-lg text-gray-500 line-through font-black mb-1" data-id="element-181">
                  Antes $49.900 ARS
                </p>
                <p className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-182">
                  🔥 HOY SOLO
                  <br data-id="element-183" />
                  <span className="text-brand-neon" data-id="element-184">$19.990 ARS</span>
                </p>
              </div>

              <Button href="https://checkout.kitonline.shop/cart/48058660487406:1" className="py-3 text-sm md:text-lg w-full" pulse={false} data-id="element-185">
                QUIERO EL MEGA PACK
              </Button>
            </div>
          </div>

          {/* Offer 2 - Most chosen - Even more flashy border */}
          <div className="relative rounded-xl p-[3px] shadow-[0_0_40px_rgba(212,161,75,0.4)] md:-translate-y-3 animate-[shimmer_3s_linear_infinite]" style={{
          background: 'linear-gradient(135deg, #F0C674 0%, #D4A14B 25%, #A8782C 50%, #D4A14B 75%, #F0C674 100%)',
          backgroundSize: '200% 200%'
        }} data-id="element-186">
            <div className="bg-brand-dark rounded-xl p-4 md:p-6 flex flex-col h-full relative" data-id="element-187">
              <div className="absolute -top-3.5 left-1/2 transform -translate-x-1/2 bg-brand-accent text-brand-dark font-black px-4 py-1 rounded-full text-[10px] md:text-xs tracking-widest shadow-xl whitespace-nowrap uppercase border-2 border-brand-dark" data-id="element-188">
                🏆 MÁS ELEGIDA
              </div>

              <div className="text-center mb-4 border-b border-white/10 pb-4 mt-2" data-id="element-189">
                <h3 className="text-sm md:text-lg font-black text-brand-neon mb-1 uppercase tracking-widest" data-id="element-190">
                  ⚡ OFERTA #2
                </h3>
                <h4 className="text-lg md:text-2xl font-black text-white uppercase leading-tight" data-id="element-191">
                  SISTEMA PROFESIONAL DE FABRICACIÓN INDUSTRIAL
                </h4>
              </div>

              <p className="text-gray-300 font-medium mb-4 text-center text-xs md:text-base leading-snug" data-id="element-192">
                Todo el Mega Pack{' '}
                <span className="text-brand-accent font-bold" data-id="element-193">MÁS</span> una
                colección avanzada de proyectos.
              </p>

              <p className="text-white font-black mb-2 text-xs md:text-base" data-id="element-194">
                Incluye:
              </p>
              <ul className="space-y-1.5 mb-4 flex-grow text-xs md:text-base font-bold text-white" data-id="element-195">
                <li data-id="element-196">👉 muebles de acero y madera,</li>
                <li data-id="element-197">👉 máquinas de gimnasio,</li>
                <li data-id="element-198">👉 estructuras metálicas,</li>
                <li data-id="element-199">👉 proyectos funcionales,</li>
                <li data-id="element-200">👉 muchísimos más planos premium.</li>
              </ul>

              <div className="bg-brand-accent/10 p-2.5 rounded-lg mb-5 border border-brand-accent/30 text-[11px] md:text-sm font-black text-brand-neon text-center leading-snug" data-id="element-201">
                ⚡ Más contenido, más proyectos y más oportunidades.
              </div>

              <div className="text-center mb-5" data-id="element-202">
                <p className="text-sm md:text-lg text-gray-500 line-through font-black mb-1" data-id="element-203">
                  Antes $79.900 ARS
                </p>
                <p className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-204">
                  🔥 HOY SOLO
                  <br data-id="element-205" />
                  <span className="text-brand-neon" data-id="element-206">$27.990 ARS</span>
                </p>
              </div>

              <Button href="https://checkout.kitonline.shop/cart/48058662715630:1" className="py-3 md:py-4 text-sm md:text-xl w-full" pulse={true} data-id="element-207">
                QUIERO EL SISTEMA COMPLETO
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-208">{`
        @keyframes shimmer {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </section>;
}